import {reportToBugsnag} from '../../srcCommon/services/bugsnag/bugsnag';

/*
 * Types.
 */

// This is compatible with Window/WindowProxy.
interface AppBrowsingContext {
  opener: AppBrowsingContext | null;
  top: AppBrowsingContext | null;
  isFrontClientLoaded?: boolean;
}

/*
 * API.
 */

export function ensureLoadedOnceInBrowsingContext(browsingContext: AppBrowsingContext): void {
  let isAlreadyLoaded = false;

  // Ensure we throw only when we want to prevent the app from being loaded.
  try {
    const rootBrowsingContext = findRootBrowsingContext(browsingContext);

    if (rootBrowsingContext.isFrontClientLoaded) {
      isAlreadyLoaded = true;
    }

    rootBrowsingContext.isFrontClientLoaded = true;
  } catch (error) {
    reportToBugsnag(error);
  }

  if (isAlreadyLoaded) {
    throw new Error('New Front has already been loaded in this browsing context.');
  }
}

/*
 * Helpers.
 */

function findRootBrowsingContext(context: AppBrowsingContext): AppBrowsingContext {
  // If this is a child window, traverse the opener. Guard against infinite recursion, just in case.
  const {opener} = context;
  if (opener && opener !== context && canAccessBrowsingContext(opener)) {
    return findRootBrowsingContext(opener);
  }

  // Otherwise, traverse the ancestry.
  const {top} = context;
  return top && canAccessBrowsingContext(top) ? top : context;
}

function canAccessBrowsingContext(context: AppBrowsingContext): boolean {
  try {
    // Try to trigger a cross-origin error.
    // eslint-disable-next-line no-unused-expressions
    context.isFrontClientLoaded;
    return true;
  } catch {
    return false;
  }
}
